import "core-js/modules/es6.promise";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.function.name";
import "regenerator-runtime/runtime";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es7.promise.finally";
import "core-js/modules/es6.number.constructor";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import NiotaClassicApiService from '../../../../services/niotaClassicApiService';
import { mapState } from 'vuex';
import formMixin from '../../formMixin';
import cloneDeep from 'lodash/cloneDeep';
import filter from 'lodash/filter';
import map from 'lodash/map';
import find from 'lodash/find';
export default {
  name: 'NiotaClassicDevicesAddAdd',
  mixins: [formMixin],
  props: {
    device: {
      type: Object,
      required: false,
      default: null
    },
    originator: {
      type: Object,
      required: false,
      default: null
    },
    deviceTypes: {
      type: Array,
      required: false,
      default: new Array()
    },
    applicationId: {
      type: Number,
      required: false,
      default: null
    },
    datasourceType: {
      type: String,
      required: false,
      default: ''
    },
    isOpen: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      deviceObject: null,
      euis: null,
      originatorDevices: [],
      showDevices: false,
      selectedItems: [],
      errors: [],
      allSelected: false,
      deviceTypeId: null,
      error: false,
      loading: false,
      tabItem: 'add-new-device'
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions'])), {}, {
    borderColor: function borderColor() {
      return this.UiTheme ? 'rgba(255, 255, 255, 0.25)' : 'transparent';
    },
    isMobile: function isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    createPossible: function createPossible() {
      if (this.datasourceType === 'firefly_mqtt' || this.datasourceType === 'firefly' || this.datasourceType === 'udp' || this.datasourceType === 'actility' || this.datasourceType === 'webhook' || this.datasourceType === 'filesystem') {
        return true;
      }

      return false;
    }
  }),
  watch: {},
  created: function created() {
    this.initData();
  },
  methods: {
    initData: function initData() {
      this.deviceObject = cloneDeep(this.device);
      this.fetchOriginatorDevices();
    },
    fetchOriginatorDevices: function fetchOriginatorDevices() {
      var _this = this;

      this.loading = true;
      NiotaClassicApiService.originatorsGetDevices(this.originator.id).then(function (res) {
        _this.originatorDevices = res.data.devices;
      }).catch(function (error) {
        _this.$snack(_this.$i18n_t('NiotaClassic.Devices.snacks.infoFindingOriginatorDevices'), 'info');

        console.error(error);
      }).finally(function () {
        return _this.loading = false;
      });
    },
    fetchDeviceInfoFromSource: function fetchDeviceInfoFromSource() {
      var _this2 = this;

      NiotaClassicApiService.applicationsFetchDeviceInfoFromSource(this.originator).then(function (res) {
        _this2.checkForError(res.euis);
      }).catch(function (error) {
        _this2.$snack(_this2.$i18n_t('NiotaClassic.Devices.snacks.infoFindingOriginatorDevices'), 'info');

        console.error(error);
      });
    },
    devicesCreate: function devicesCreate() {
      var _this3 = this;

      this.loading = true;
      return NiotaClassicApiService.devicesCreate(this.selectedItems).then(function (res) {
        if (!res.err) {
          _this3.error = false;

          _this3.$snack(_this3.$i18n_t('NiotaClassic.Devices.snacks.deviceUpdated'), 'success');
        } else if (res.data.err) {
          _this3.error = true;

          _this3.$snack(res.data.err, 'error');
        } else {
          _this3.error = true;

          _this3.$snack(res.err, 'error');
        }
      }).catch(function (error) {
        _this3.$snack(_this3.$i18n_t('NiotaClassic.Devices.snacks.deviceUpdateFaild'), 'error');

        console.error(error);
      }).finally(function () {
        _this3.loading = true;
      });
    },
    selectItem: function selectItem(item, key) {
      if (this.originatorDevices[key].selected) {
        this.originatorDevices[key].selected = !this.originatorDevices[key].selected;
        this.selectedItems = filter(this.selectedItems, function (device) {
          return device.eui !== item.eui;
        });
      } else {
        this.originatorDevices[key].selected = true;
        var index = find(this.selectedItems, function (device) {
          return device.eui === item.eui;
        });

        if (!index) {
          this.selectedItems.push(item);
        }
      }
    },
    searchDevices: function searchDevices() {
      if (this.euis) {
        this.originator.euis = this.euis.trim();
        this.originator.applicationId = this.applicationId;
        this.fetchDeviceInfoFromSource();
      }
    },
    updateSelectedList: function updateSelectedList(item) {
      this.selectedItems = filter(this.selectedItems, function (device) {
        return device.eui !== item.eui;
      });
      this.errors = filter(this.selectedItems, function (device) {
        return !device.valid && device.errorMessage;
      });
      this.originatorDevices = map(this.originatorDevices, function (device) {
        if (device.eui === item.eui) {
          delete device.selected;
        }

        return device;
      });

      if (!this.selectedItems.length) {
        this.allSelected = false;
      }
    },
    checkForError: function checkForError(euis) {
      var _this4 = this;

      euis.forEach(function (eui) {
        if (!eui.valid && eui.errorMessage) {
          _this4.errors.push(eui);
        }

        var index = find(_this4.selectedItems, function (device) {
          return device.eui === eui.eui;
        });

        if (!index) {
          _this4.selectedItems.push(eui);
        }
      });
    },
    addItem: function () {
      var _addItem = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!this.selectedItems.length) {
                  _context.next = 4;
                  break;
                }

                this.assignData();
                _context.next = 4;
                return this.devicesCreate();

              case 4:
                if (!this.error) {
                  this.$emit('refreshList');
                  this.$emit('close');
                }

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function addItem() {
        return _addItem.apply(this, arguments);
      }

      return addItem;
    }(),
    selectAllDevices: function selectAllDevices(select) {
      var _this5 = this;

      this.originatorDevices = map(this.originatorDevices, function (device) {
        if (select) {
          device.selected = select;
          var result = find(_this5.selectedItems, function (item) {
            return item.eui === device.eui;
          });

          if (!result) {
            _this5.selectedItems.push(device);
          }

          _this5.allSelected = true;
        } else {
          delete device.selected;
          _this5.selectedItems = [];
          _this5.allSelected = false;
        }

        return device;
      });
    },
    setDeviceTypeId: function setDeviceTypeId(deviceTypeId) {
      this.deviceTypeId = deviceTypeId;
    },
    setOperationalStatus: function setOperationalStatus(status) {
      this.operationalStatus = status;
    },
    assignData: function assignData() {
      var _this6 = this;

      this.selectedItems = map(this.selectedItems, function (item) {
        // if (this.datasourceType === 'firefly_mqtt' || this.datasourceType === 'firefly') {
        return _this6.newDevice(item); // }
      });
    },
    newDevice: function newDevice(device) {
      if (device.lorawan_device) {
        device.adr_limit = device.lorawan_device.adr_limit;
      }

      var properties = {
        operational_status: this.operationalStatus
      };
      return {
        valid: true,
        add: true,
        name: device.name,
        lorawan_device: {
          nwk_s_key: device.network_session_key,
          dev_addr: device.address,
          app_s_key: device.application_session_key,
          app_key: device.application_key,
          adr_limit: device.adr_limit
        },
        eui: device.eui,
        description: device.description,
        applicationId: this.applicationId,
        originatorId: this.originator.id,
        deviceTypeId: this.deviceTypeId,
        properties: properties,
        externalId: device.ref
      };
    },
    addNewItem: function addNewItem() {
      this.$emit('addNewItem');
    }
  }
};